let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("6mtZ9")).then(() => parcelRequire('dkMw7'));